// import babelPolyfill from 'babel-polyfill';
const Validation = require('folktale/validation');
const Success = Validation.Success;
const Failure = Validation.Failure;
const R = require('ramda');
const RF = require('ramda-fantasy');

const isEmail =
	/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
const isPassword =
	/((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*_\-+=`|\(\){}\[\]:;"'<>,.?\/]).{8,})/;
const isStrongPassword =
	/((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*_\-+=`|\(\){}\[\]:;"'<>,.?\/]).{15,})/;
const isPhoneNumber = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
const isEtos = /^(3300|7000)/g;
const isUrl = /(https?:\/\/[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/[a-zA-Z0-9]+\.[^\s]{2,})/

module.exports = exports = {
	append: R.append,
	compose: R.compose,
	curry: R.curry,
	curryN: R.curryN,
	Failure: Failure,
	isNil: R.isNil,
	isEmpty: R.isEmpty,
	isNumber: (n) => R.is(Number, n) && !Number.isNaN(n) && Number.isFinite(n),
	isInteger: (n) =>
		n === '' || (!isNaN(n) && ((x) => (x | 0) === x)(parseFloat(n))),
	isString: R.is(String),
	isPassword: (str) => isPassword.test(str),
	isStrongPassword: (str) => isStrongPassword.test(str),
	isEmail: (str) => isEmail.test(str),
	isPhoneNumber: (str) => isPhoneNumber.test(str) && str.length >= 6,
	isDate: (str) => validateDate(str),
	isEtos: (str) => isEtos.test(str),
	isUrl: (str) => isUrl.test(str),
	mapObjIndexed: R.mapObjIndexed,
	Maybe: RF.Maybe,
	path: R.path,
	Success: Success,
	Validation: Validation,
};

// Copyright (c) 2017, Dirk-Jan Rutten
const validateDate = (date) => {
	const leapYear = (year) =>
		(year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	const RFC_3339_REGEX = /^(\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01]))$/;

	if (!RFC_3339_REGEX.test(date)) return false;

	const year = Number(date.substr(0, 4));
	const month = Number(date.substr(5, 2));
	const day = Number(date.substr(8, 2));

	if (month === 2) {
		return !((leapYear(year) && day > 29) || (!leapYear(year) && day > 28));
	} else if (
		(month === 4 || month === 6 || month === 9 || month === 11) &&
		day > 30
	) {
		return false;
	}

	return true;
};
